// @flow
import styled from "styled-components";

export const FormGroup = styled.div`
    display: flex;
    align-items: center;
	margin: 0 0 20px 0;
`;

export default FormGroup;